import { Select,Form } from 'antd'
import React, { useEffect, useState } from 'react'
import { useBnsYiXiangKeHuListQuery } from '../../store/ReactWebSiteApi';
function ClientSelect(props) {    
    const {data,isSuccess} = useBnsYiXiangKeHuListQuery({byxkh_e_id:'218'},{refetchOnMountOrArgChange:1})    
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                const newArr = data.Result.map(item => {
                    const {byxkh_id:key,byxkh_name,} = item;
                    return item = {value:key,label:byxkh_name,}
                })                
               
                setList(newArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    return (
        <>
            <Form.Item 
                label={props.label} 
                wrapperCol={props.wrapperCol} 
                required={props.required}
                name={props.name}
            >
                <Select 
                    options={list} 
                                    onChange={(_,f) => {
                    props.onChange(f.value,f.label,f.ed_id,f.ed_name)
                }}
                    placeholder={props.placeholder}
                    style={props.style}
                />
            </Form.Item>
        </>
    )
}

export default ClientSelect